export function buildAlternativesListByProjectIdQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesLists.Queries.AlternativesListByProjectIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildRelationshipsByProjectIdQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesLists.Queries.RelationshipsByProjectIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}


export function buildKanbanPageQueryV1(workspaceId: number, projectId: number, viewDefId: string | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesLists.Queries.KanbanPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ViewDefId': viewDefId
	}
}

export function buildGridPageQueryV1(workspaceId: number, projectId: number, viewDefId: string | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesLists.Queries.GridPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ViewDefId': viewDefId
	}
}



export function buildStatusDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, statusId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesLists.Queries.StatusDependenciesQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'StatusId': statusId,
	}
}

export function buildAlternativesComparisonQueryV1(workspaceId: number, projectId: number, viewDefId: string | null, alternativeIds: string[], formId: number | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesLists.Queries.AlternativesComparisonQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ViewDefId': viewDefId,
		'AlternativeIds': alternativeIds,
		'FormId': formId
	}
}






